/**
 * @generated SignedSource<<dafcfe72f50d7eda2608a980033b00ee>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type Metric_metric$fragmentType: FragmentType;
export type Metric_metric$data = {|
  +label: string,
  +url: ?string,
  +value: ?string,
  +$fragmentType: Metric_metric$fragmentType,
|};
export type Metric_metric$key = {
  +$data?: Metric_metric$data,
  +$fragmentSpreads: Metric_metric$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Metric_metric",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "PipelineMetric",
  "abstractKey": null
};

(node/*: any*/).hash = "ae8f411ba59b2aedb877bbed4ae6063d";

module.exports = ((node/*: any*/)/*: Fragment<
  Metric_metric$fragmentType,
  Metric_metric$data,
>*/);
